export enum GAME_LISTS {
  BANKER_PLAYER = 'H_BP',
  H_NIUNIU = 'H_NIUNIU',
}

export interface GameRuleForm<T> {
  value?: T;
  gameId: string;
}

export declare type FormElement = (props: GameRuleForm<any>) => JSX.Element;
